import { downgradeComponent } from '@angular/upgrade/static';
import { module } from 'angular';

import { ActivityButtonComponent, ActivityComponent } from '@contact/upgrade';

import { AppointmentPopup, default as appointmentPopupName } from './popup/appointment-popup.component';
import { AppointmentTargetForm, default as appointmentTargetFormName } from './targets/appointment-target-form.component.ajs';
import { AppointmentTransferPopup, default as appointmentPopupTransferName } from './transfer-popup/appointment-transfer-popup.component';

export default module('contact.agent.core.contact.appointment', [])
  .component(appointmentPopupTransferName, new AppointmentTransferPopup())
  .component(appointmentPopupName, new AppointmentPopup())
  .component(appointmentTargetFormName, new AppointmentTargetForm())
  // DOWNGRADED COMPONENT
  .directive('cngActivity', downgradeComponent({ component: ActivityComponent }) as angular.IDirectiveFactory)
  .directive('cngActivityBtn', downgradeComponent({ component: ActivityButtonComponent }) as angular.IDirectiveFactory).name;
